import { ButtonHTMLAttributes, FC, CSSProperties } from 'react';

// import { MoonLoader } from 'react-spinners';
import UseAnimations from 'react-useanimations';
import loadingIcon from 'react-useanimations/lib/loading';

import { Container, TextContainer } from './styles';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  loading?: boolean;
  buttonDisable?: boolean;
  extraStyles?: CSSProperties;
  size?: 'normal' | 'small';
  variant?: 'yellow' | 'black' | 'red' | 'border';
  icon?: JSX.Element;
  textContent?: string;
  textColor?: string;
  textFont?: string;
  letterSpacing?: boolean;
};

const Button: FC<ButtonProps> = ({
  loading,
  buttonDisable,
  extraStyles,
  textContent,
  icon,
  children,
  textColor,
  textFont,
  ...rest
}) => (
  <Container
    type="button"
    disabled={buttonDisable}
    buttonDisable={buttonDisable}
    style={extraStyles}
    {...rest}
  >
    {loading ? (
      <UseAnimations animation={loadingIcon} size={56} />
    ) : (
      <TextContainer color={textColor} fontSize={textFont}>
        {icon}
        {children}
        <p>{textContent}</p>
      </TextContainer>
    )}
  </Container>
);

export default Button;
